import { CareNet, SystemName } from "constants/captions"

export const Home = () => {
  return (
    <>
      <h1>welcome to {CareNet} {SystemName} web page.</h1>
    </>
  )
}